var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._g({ staticClass: "input-slider-component" }, _vm.computedListeners),
    [
      _vm.showIncreaseDecreaseButtons
        ? _c(
            "IconComponent",
            {
              staticClass: "input-slider-increase-button",
              on: {
                click: _vm.onDecreaseClick,
                mousedown: _vm.onDecreaseMouseDown,
                touchstart: _vm.onDecreaseMouseDown,
              },
            },
            [_vm._v("zoom_in")]
          )
        : _vm._e(),
      _c(
        "div",
        {
          ref: "inputSlider",
          staticClass: "input-slider",
          style: _vm.sliderStyle,
        },
        [
          _c("input", {
            staticClass: "input-slider-input",
            attrs: { max: _vm.max, min: _vm.min, type: "range" },
            domProps: { value: _vm.internalValue },
            on: {
              input: _vm.onSliderInput,
              change: _vm.onSliderChange,
              mousedown: _vm.onSliderMouseDown,
              touchmove: _vm.onSliderTouchMove,
              touchstart: _vm.onSliderTouchStart,
            },
          }),
          _vm.showSteps
            ? _c(
                "div",
                { staticClass: "input-slider-steps" },
                _vm._l(_vm.max - _vm.min + 1, function (n) {
                  return _c(
                    "div",
                    { staticClass: "input-slider-step-container" },
                    [_c("div", { staticClass: "input-slider-step" })]
                  )
                }),
                0
              )
            : _vm._e(),
          _c("div", {
            ref: "inputSliderTrack",
            staticClass: "input-slider-track",
          }),
          _c(
            "div",
            {
              ref: "inputSliderHandle",
              staticClass: "input-slider-handle",
              style: _vm.sliderHandleStyle,
            },
            [_c("IconComponent", [_vm._v("slider_thumb")])],
            1
          ),
        ]
      ),
      _vm.showIncreaseDecreaseButtons
        ? _c(
            "IconComponent",
            {
              staticClass: "input-slider-decrease-button",
              on: {
                click: _vm.onIncreaseClick,
                mousedown: _vm.onIncreaseMouseDown,
                touchstart: _vm.onIncreaseMouseDown,
              },
            },
            [_vm._v("zoom_out")]
          )
        : _vm._e(),
      _vm.showValue
        ? _c("div", { staticClass: "input-slider-value" }, [
            _c("span", { staticClass: "input-slider-value-span" }, [
              _vm._v(_vm._s(_vm.internalValue)),
            ]),
            _c("input", {
              staticClass: "input-slider-value-input",
              attrs: { min: _vm.min, max: _vm.max, type: "number" },
              domProps: { value: _vm.internalValue },
              on: { input: _vm.onInputInput, change: _vm.onInputChange },
            }),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }